import { Component, Input, OnInit } from '@angular/core';
import { LenderService } from '@shared/service/lender/lender.service';
import { WidgetContextData, WidgetStates, WorkflowWidgetCustomConfig, WorkflowWidgetState } from '@workflow/widget-context.type';
import { unitTestSensitiveData } from 'src/const/testing.const';

// UPDATE: Revisit this entire ts file - may not need this entry point for ECP
@Component({
  selector: 'ecp-workflow',
  template: ` <ng-container *ngIf="widgetContext">
    <cudc-dynamic-workflow
      class="bl-display--block"
      [widgetContext]="widgetContext"
      [loanManagement]="loanManagement"
      (widgetStateChange)="widgetStateChanged($event)"
    >
    </cudc-dynamic-workflow>
    <ecp-dynamic-app-registry></ecp-dynamic-app-registry>
  </ng-container>`,
  standalone: false
})
export class EcpWorkflowComponent implements OnInit {
  @Input() flowId = '';
  @Input() loanManagement = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-redundant-type-constituents
  @Input() customConfig: WorkflowWidgetCustomConfig | any;

  // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
  public widgetContext: WidgetContextData | undefined;
  public widgetState: WidgetStates = '';

  public widgetStateChanged(widgetEvent: WorkflowWidgetState): void {
    this.widgetState = widgetEvent.state;
  }

  constructor(
    private lenderService: LenderService
  ) {}

  ngOnInit() {
    // TODO 208381: Let's look at how we're initializing configs. See 208381.
    this.widgetContext = {
      tenantId: this.lenderService.lenderDataInfo.tenantId,
      appId: '98234',
      authToken: unitTestSensitiveData.jwt, // Temp fix to appease the Snyk gods, we can probably this context now WW is inside this repo
      config: {
        isProd: false,
        flowId: this.flowId,
        // This is a sample data
        // use it in config like "#{widget:appName}", "#{widget:setting/someText}"
        customConfig: this.customConfig
      }
    };
  }
}
